var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSzambelanJednostkiWylaczone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M121.6 81.067h-6.4V61.549a6.086 6.086 0 0 0-6.082-6.082H67.2v-12.8h9.6a6.4 6.4 0 0 0 6.4-6.4v-19.2a6.4 6.4 0 0 0-6.4-6.4H51.2a6.4 6.4 0 0 0-6.4 6.4v19.2a6.4 6.4 0 0 0 6.4 6.4h9.6v12.8H18.882a6.086 6.086 0 0 0-6.082 6.082v19.518H6.4a6.4 6.4 0 0 0-6.4 6.4v19.2a6.4 6.4 0 0 0 6.4 6.4h19.2a6.4 6.4 0 0 0 6.4-6.4v-19.2a6.4 6.4 0 0 0-6.4-6.4h-6.4v-19.2h41.6v19.2h-6.4a6.4 6.4 0 0 0-6.4 6.4v19.2a6.4 6.4 0 0 0 6.4 6.4h19.2a6.4 6.4 0 0 0 6.4-6.4v-19.2a6.4 6.4 0 0 0-6.4-6.4h-6.4v-19.2h41.6v19.2h-6.4a6.4 6.4 0 0 0-6.4 6.4v19.2a6.4 6.4 0 0 0 6.4 6.4h19.2a6.4 6.4 0 0 0 6.4-6.4v-19.2a6.4 6.4 0 0 0-6.4-6.4zm-70.4-44.8v-19.2h25.6v19.2H51.2zm21.602 69.59a2.725 2.725 0 0 1-3.878 0L64 100.934l-4.924 4.921c-1.064 1.08-2.814 1.064-3.878 0a2.752 2.752 0 0 1 0-3.875l4.924-4.92-4.924-4.922a2.752 2.752 0 0 1 0-3.875 2.756 2.756 0 0 1 3.878 0L64 93.185l4.924-4.921a2.756 2.756 0 0 1 3.878 0 2.752 2.752 0 0 1 0 3.875l-4.924 4.921 4.924 4.921a2.752 2.752 0 0 1 0 3.875zM24.596 88.263a2.724 2.724 0 0 1 0 3.877l-4.92 4.922 4.92 4.923a2.754 2.754 0 0 1 0 3.877c-1.063 1.08-2.812 1.063-3.875 0L15.8 100.94l-4.921 4.923c-1.063 1.08-2.812 1.063-3.875 0a2.754 2.754 0 0 1 0-3.877l4.92-4.923-4.92-4.922a2.754 2.754 0 0 1 0-3.877 2.752 2.752 0 0 1 3.875 0l4.921 4.923 4.921-4.923a2.752 2.752 0 0 1 3.875 0zm96.194 0a2.724 2.724 0 0 1 0 3.877l-4.921 4.922 4.92 4.923a2.754 2.754 0 0 1 0 3.877c-1.062 1.08-2.811 1.063-3.874 0l-4.921-4.923-4.922 4.923c-1.063 1.08-2.812 1.063-3.875 0a2.754 2.754 0 0 1 0-3.877l4.921-4.923-4.92-4.922a2.754 2.754 0 0 1 0-3.877 2.752 2.752 0 0 1 3.874 0l4.922 4.923 4.92-4.923a2.752 2.752 0 0 1 3.876 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 116,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 8,
    d: "M0 116c0 64.065 51.935 116 116 116s116-51.935 116-116S180.065 0 116 0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.384,
    transform: "translate(52 52)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.38,
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzambelanJednostkiWylaczone);
export default __webpack_public_path__ + "static/media/szambelan_jednostki_wylaczone.8ebf3c06aa70b8c0e480e8ab050a94cc.svg";
export { ForwardRef as ReactComponent };